import { atomFamily } from "jotai/utils";

import { NaturalEventType } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionNaturalEventAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`naturalEvent-${sessionId}`, null as NaturalEventType | null)
);
export const naturalEventAtom = createDerivedSessionAtom<NaturalEventType | null>(sessionNaturalEventAtom);
